/**
 * Types of criteria that can be added to a promotion packet
 */
export enum CriterionType {
  TECHNICAL = 'TECHNICAL',
  LEADERSHIP = 'LEADERSHIP',
  IMPACT = 'IMPACT',
  COLLABORATION = 'COLLABORATION'
}

/**
 * A criterion in a promotion packet
 */
export interface Criterion {
  id: string;
  packetId: string;
  criterionType: CriterionType;
  description: string;
  evidence: string;
  createdAt: Date;
  updatedAt: Date;
}

/**
 * Data required to create a new criterion
 */
export interface CreateCriterionDTO {
  packetId: string;
  criterionType: CriterionType;
  description: string;
  evidence: string;
}

/**
 * Data that can be updated on a criterion
 */
export interface UpdateCriterionDTO {
  criterionType: CriterionType;
  description: string;
  evidence: string;
}

/**
 * Validation rules for criteria
 */
export const CRITERIA_VALIDATION = {
  MAX_CRITERIA_PER_TYPE: 3,
  MAX_DESCRIPTION_LENGTH: 500,
  MAX_EVIDENCE_LENGTH: 5000,
  MAX_CRITERIA_TOTAL: 10,
} as const; 